import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptyState, FlexBox } from '@dixa/lib-shared-habla';
import { useNavigate } from 'react-router-dom';
import Error404 from '../../images/404.png';
import Image from '../shared/Image/Image';
import styles from './notFound.module.scss';
export const NotFound = ({ navigatePath, name, }) => {
    const navigate = useNavigate();
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "400", alignItems: "center", justifyContent: "center", width: "100%", height: "100%", background: "neutral.000" }, { children: [_jsx(Image, { src: Error404, alt: "404-img", className: styles.image }), _jsx(EmptyState, { title: "Oops, page not found!", description: "We can't seem to find the page you're looking for.", icon: null, buttonProps: {
                    children: `Go to ${name}`,
                    onClick: () => navigate(navigatePath),
                } })] })));
};
